import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { QuestionCircle } from 'react-bootstrap-icons';
import './HelpIcon.css';

const HelpIcon = ({ text, placement = 'right' }) => {
    return (
        <OverlayTrigger
            placement={placement}
            overlay={<Tooltip>{text}</Tooltip>}
        >
            <span className="help-icon">
                <QuestionCircle />
            </span>
        </OverlayTrigger>
    );
};

export default HelpIcon;
